import axios from "axios";
const backend1Axios = axios.create({
  baseURL: 'https://backend1.melindadev.com/' + 'api/',
  headers: { "Content-Type": "application/json", Accept: "application/json" }
});

backend1Axios.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${sessionStorage.getItem("authToken")}`;
  return config;
});

export default backend1Axios;